module.exports = "/_next/static/images/invoice-financing-fc3f6e08edb3d47fa8fff8ac76fc8a5e.svg";